export const GET_FARMS = 'farms/GET_FARMS';
export const GET_FARMS_SUCCESS = 'farms/GET_FARMS_SUCCESS';
export const GET_FARMS_FAILED = 'farms/GET_FARMS_FAILED';
export const CREATE_FARM = 'farms/CREATE_FARM';
export const CREATE_FARM_SUCCESS = 'farms/CREATE_FARM_SUCCESS';
export const CREATE_FARM_FAILED = 'farms/CREATE_FARM_FAILED';